import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ContextMenuItem from '../../../../../react/features/base/ui/components/web/ContextMenuItem';
// @ts-ignore
import { IconPIP } from '../../../base/icons/svg';
import { togglePIP } from '../../actions';
import { STATUSES } from '../../constants';
function PiPButton() {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { pipStatus } = useSelector((state) => state['wildix/features/PiP']);
    const onClick = useCallback(() => {
        dispatch(togglePIP());
    }, []);
    const getTranslate = useMemo(() => {
        if (pipStatus === STATUSES.PLAYING) {
            return t('PiP.titleDisable');
        }
        return t('PiP.titleEnable');
    }, []);
    return (React.createElement(ContextMenuItem, { accessibilityLabel: t('PiP.accessibilityLabel'), className: 'pictureInPicture', text: getTranslate, icon: IconPIP, onClick: onClick }));
}
export default PiPButton;
